export const PalettePrimaryBase = "#0B3C80";
export const PalettePrimaryContrastText = "#FFFFFF";
export const PalettePrimaryTint100 = "#E7EBF2";
export const PalettePrimaryTint200 = "#B6C5D9";
export const PalettePrimaryTint300 = "#5477A6";
export const PalettePrimaryTint500 = "#09336D";
export const PalettePrimaryTint600 = "#072753";
export const PalettePrimaryTint700 = "#03263B";
export const PaletteSecondaryBase = "#0B3C80";
export const PaletteSecondaryContrastText = "#FFFFFF";
export const PaletteSecondaryTint100 = "#E7EBF2";
export const PaletteSecondaryTint200 = "#B6C5D9";
export const PaletteSecondaryTint300 = "#5477A6";
export const PaletteSecondaryTint500 = "#09336D";
export const PaletteSecondaryTint600 = "#072753";
export const PaletteSecondaryTint700 = "#03263B";
export const PaletteTertiaryBase = "#DBD1C9";
export const PaletteTertiaryContrastText = "#000000";
export const PaletteTertiaryTint100 = "#F7F4F3";
export const PaletteTertiaryTint200 = "#F1EDE9";
export const PaletteTertiaryTint300 = "#E4DDD7";
export const PaletteTertiaryTint500 = "#BAB2AB";
export const PaletteTertiaryTint600 = "#8E8883";
export const PaletteTertiaryTint700 = "#6E6965";
export const PaletteAccentBase = "#FF5C00";
export const PaletteAccentContrastText = "#FFFFFF";
export const PaletteAccentTint100 = "#FCF0E7";
export const PaletteAccentTint200 = "#F6C8AB";
export const PaletteAccentTint300 = "#FF8E5C";
export const PaletteAccentTint500 = "#E55200";
export const PaletteAccentTint600 = "#B34000";
export const PaletteAccentTint700 = "#802E00";
export const PaletteTextBody = "#03263B";
export const PaletteTextHeading = "#0B3C80";
export const PaletteTextPrice = "#0B3C80";
export const PaletteTextLink = "#0B3C80";
export const PaletteBackgroundBody = "#F7F4F3";
export const PaletteBackgroundContent = "#FFFFFF";
export const PaletteBackgroundOffset = "#F7F4F3";
export const PaletteDivider = "#F7F4F3";
export const PaletteBorder = "#E4DDD7";
export const PaletteStarRating = "#FF5C00";
export const PaletteMappingsNeutral = "tertiary";
export const TypographyBaseFontSize = 16;
export const TypographyBaseLineHeight = 1.5;
export const TypographyFamilyBodyFontFamily = "'Manrope', arial, sans-serif";
export const TypographyFamilyBodyFontWeightDefault = 400;
export const TypographyFamilyBodyFontWeightSemiBold = 600;
export const TypographyFamilyBodyFontWeightBold = 800;
export const TypographyFamilyHeadingFontFamily = "'Manrope', arial, sans-serif";
export const TypographyFamilyHeadingFontWeightDefault = 800;
export const TypographyFamilyHeroFontFamily = "'Bebas Neue', arial, sans-serif";
export const TypographyFamilyHeroFontWeightDefault = 400;
export const TypographyFamilyHeroTextTransform = "uppercase";
export const TypographyFamilyPriceFontFamily = "'Bebas Neue', arial, sans-serif";
export const TypographyFamilyPriceFontWeightDefault = 400;
